import { useState } from "react";
import EndGameStats from "../../model/endGameStats";
import { setEndGameStats } from "../providers/setEndGameStats";

export function useEndGameStats(): [EndGameStats, Function] {
    const [state, setState] = useState({
        currentRating: "...",
        changeInRating: "...",
        currentExperiencePoints: "...",
        changeInExperiencePoints: "...",
    });

    return [state,
        (field: string, value: string) => setEndGameStats(setState, field, value),
    ];

}
